import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-03c11d2e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "rankOfficial"
};
var _hoisted_2 = {
  class: "official"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "offi-title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-netease-cloud-music-fill"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "官方榜")], -1
  /* HOISTED */
  );
});

var _hoisted_4 = {
  class: "offi"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "left-img-box"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-netease-cloud-music-line"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-icon-test"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_9 = {
  class: "offi-item-right"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "right-index"
};
var _hoisted_12 = {
  class: "right-name"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", null, "-", -1
  /* HOISTED */
  );
});

var _hoisted_14 = {
  class: "second"
};
var _hoisted_15 = ["onClick"];

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "查看全部", -1
  /* HOISTED */
  );
});

var _hoisted_17 = {
  class: "update"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 官方榜 "), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.officialList, function (item1, index1) {
    return _openBlock(), _createElementBlock("div", {
      class: "offi-item",
      style: _normalizeStyle({
        backgroundColor: _ctx.offiBgc[index1]
      }),
      key: index1
    }, [_createCommentVNode(" 左边图片 "), _createElementVNode("div", {
      class: "offi-item-left",
      onClick: function onClick($event) {
        return _ctx.rankClick(item1.id);
      }
    }, [_createElementVNode("div", {
      class: "left-img-title",
      style: _normalizeStyle({
        color: _ctx.offiColor[index1]
      })
    }, _toDisplayString(item1.name), 5
    /* TEXT, STYLE */
    ), _createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createVNode(_component_el_image, {
      src: item1.coverImgUrl
    }, null, 8
    /* PROPS */
    , ["src"])])], 8
    /* PROPS */
    , _hoisted_5), _createCommentVNode(" 右边列表 "), _createElementVNode("div", _hoisted_9, [_createCommentVNode(" 前三首歌 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.tracks, function (item2, index2) {
      return _openBlock(), _createElementBlock("div", {
        class: "right-item",
        key: index2,
        onClick: function onClick($event) {
          return _ctx.rankClick(item1.id);
        }
      }, [_createElementVNode("span", _hoisted_11, _toDisplayString(index2 + 1) + ".", 1
      /* TEXT */
      ), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
        class: "first",
        style: _normalizeStyle({
          color: _ctx.offiColor[index1]
        })
      }, _toDisplayString(item2.first), 5
      /* TEXT, STYLE */
      ), _hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(item2.second), 1
      /* TEXT */
      )])], 8
      /* PROPS */
      , _hoisted_10);
    }), 128
    /* KEYED_FRAGMENT */
    )), _createElementVNode("div", {
      class: "view-all",
      onClick: function onClick($event) {
        return _ctx.rankClick(item1.id);
      }
    }, [_hoisted_16, _createVNode(_component_el_icon, null, {
      default: _withCtx(function () {
        return [_createVNode(_component_ArrowRight)];
      }),
      _: 1
      /* STABLE */

    })], 8
    /* PROPS */
    , _hoisted_15)]), _createElementVNode("div", _hoisted_17, _toDisplayString(item1.updateFrequency), 1
    /* TEXT */
    )], 4
    /* STYLE */
    );
  }), 128
  /* KEYED_FRAGMENT */
  ))])])]);
}